import { TCouponDetails } from '../../S/pricing/types';

export const ITR_PLAN_PRODUCT_SERVICE_SUBSTRING = 'ITR-SCO';

export const getPercentageDiff = (a: number, b: number): number => {
  if (isNaN(a) || isNaN(b)) return 0;
  return Math.round(((a - b) / a) * 100);
};

export const getRupeePercentagePrefix = (
  type: string,
  amount: number
): string => {
  const roundedAmount = Math.ceil(amount);
  return type === 'PERCENTAGE' ? `${roundedAmount}%` : `₹${roundedAmount}`;
};

export const getDiscountValueText = (
  coupon: TCouponDetails,
  originalPrice: number,
  discountedPrice: number,
  isItrPlan: boolean
): string => {
  //MP-Plans
  if (!isItrPlan)
    return `(-${getPercentageDiff(originalPrice, discountedPrice)}%)`;
  // ITR Plans
  if (coupon) {
    return `(-${getRupeePercentagePrefix(
      coupon.discountType,
      coupon.discountValue
    )})`;
  }
  return '';
};
